import { BundleType } from "../BundleType"
import { IShippingAddress } from "./IShippingAddress"

export type SHIPPINGMETHOD = "Standard" | "Premium" | "Priority Express"

export type PACKAGETYPE = "ulab_packaging" | "custom_packaging"

export enum RetainerFasttrackOrderType {
  RETAINER_UASSIST = "Retainer uAssist",
  BRACKET_REMOVAL_UASSIST = "Bracket Removal uAssist",
}

export interface IRetainerFasttrackOrderPayload {
  case_id: string
  order_type: RetainerFasttrackOrderType | null | undefined
  upper_type?: string
  lower_type?: string
  is_refinement?: boolean
  sub_orders?: number
}

export interface IAlignerOrder {
  bundle: {
    pricing_option: string
    aligner: {
      remaining: number
      requested: number
      included: number
    }
    retainer: {
      remaining: number
      requested: number
      included: number
    }
    template:{
      remaining: number
      requested: number
      included: number
    }
    alignercase: {
      cost: number
      count: number
    }
    previous_uassist_credit: number
    shipping_price: { type: string; item_total_value: string }
    custom_packaging: number
    tax_amt: number
    sub_total: number
    type: BundleType
  }
  alacarte: {
    pricing_option: string
    aligner: {
      cost: number
      count: number
    }
    custom_package: {
      cost: number
      count: number
    }
    uassist_service: {
      cost: number
      count: number
    }
    retainer: {
      cost: number
      count: number
    }
    template: {
      cost: number
      count: number
    }
    alignercase: {
      cost: number
      count: number
    }
    shipping_price: { type: string; item_total_value: string }
    custom_packaging: number
    tax_amt: number
    sub_total: number
  }
  packageType: PACKAGETYPE
  shippingMethod: SHIPPINGMETHOD
  shipAddress: ShipToAddress
  total: number
  currency: string
  orderId: number
  subOrderId: number
  promo_code: PromoCode[]
  bundle_price: number
}

export interface ShipToAddress extends IShippingAddress {
  business_name: string
  phone: string
}

export interface PromoCode {
  message: string
  code: string
  error_code: string
  discount: number
}

export interface IAlignerOrderPayload {
  case_id: number
  shipping_method: SHIPPINGMETHOD
  order_type: string
  upper_stage_range: string
  lower_stage_range: string
  upper_stage_count: number
  lower_stage_count: number
  upper_retainer_stage: string
  lower_retainer_stage: string
  upper_template_stage: string
  lower_template_stage: string
  aligner_material: string
  thickness: string
  package_type: PACKAGETYPE | ""
  upper_left_aligner_coverage: string
  upper_right_aligner_coverage: string
  lower_left_aligner_coverage: string
  lower_right_aligner_coverage: string
  upper_left_lasttoothtocover: string
  upper_right_lasttoothtocover: string
  lower_left_lasttoothtocover: string
  lower_right_lasttoothtocover: string
  shipping_address_id: number
  extra_info: string
  pricing_option: string
  quote: object
  complete_upper_stage: string
  complete_lower_stage: string
  complete_upper_retainer: string
  complete_lower_retainer: string
  complete_upper_template: string
  complete_lower_template: string
  pricing_id: string
  aligner_case: number
  stage: {
    aligners: { up: number[]; low: number[] }
    retainers: { up: number; low: number }
    templates: { up: number; low: number }
  }
  materials: { aligner: object[]; retainer: object[] }
  scanned: number[]
  recession: number[]
  coverage: object
  extra: object
  promo_code: string[]
  has_active_bundle: boolean
}
